import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Snackbar from '@mui/material/Snackbar';
import { nextSnackbar } from './snackbarReducer';

class SnackbarManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: Boolean(props.message),
    };
  }

  componentDidUpdate(prevProps) {
    if (!this.state.open && this.props.message && this.props.message !== prevProps.message) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ open: true });
    }
  }

  handleClose = () => this.setState({ open: false });
  handleExited = () => this.props.dispatch(nextSnackbar());

  render() {
    return (
      <Snackbar
        message={this.props.message}
        open={this.state.open}
        onClose={this.handleClose}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionProps={{
          onExited: this.handleExited,
        }}
      />
    );
  }
}

SnackbarManager.propTypes = {
  dispatch: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]).isRequired,
};

function mapStateToProps({ snackbars: state }) {
  return {
    message: state.current,
  };
}

export default connect(mapStateToProps)(SnackbarManager);
